import { adminApiRequest } from "../../utils/apiUtils";

export enum EventAttendeeType {
  YOUTUBER = "YOUTUBER",
  AMBASSADOR = "AMBASSADOR",
}

export interface EvnetScheduleRequest {
  date: string;
  title: string;
  pubName: string;
  pubId: number;
  attendeeId: number;
  attendeeName: string;
  link: string;
}

export const EventScheduleAPI = {
  getEventSchedule: (
    search: string,
    page: number,
    limit: number,
    isAsc: boolean,
    month?: number,
    year?: number
  ) => {
    if (month && year) {
      return adminApiRequest
        .get(
          `/event-schedule?search=${search}&page=${page}&limit=${limit}&month=${month}&year=${year}&isAsc=${isAsc}`
        )
        .then((res) => res);
    } else {
      return adminApiRequest
        .get(
          `/event-schedule?search=${search}&page=${page}&limit=${limit}&isAsc=${isAsc}`
        )
        .then((res) => res);
    }
  },
  getEventAttendee: () => {
    return adminApiRequest.get(`/event-schedule/attendee`).then((res) => res);
  },
  registerEventSchedule: (request: FormData) => {
    return adminApiRequest.post("/event-schedule", request).then((res) => res);
  },
  registerEventAttendee: (formData: FormData) => {
    return adminApiRequest
      .post("/event-schedule/attendee", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res);
  },
  updateEventSchedule: (id: number, request: FormData) => {
    return adminApiRequest
      .put(`/event-schedule/update/${id}`, request)
      .then((res) => res);
  },
  updateEventAttendee: (id: number, formData: FormData) => {
    return adminApiRequest
      .put(`/event-schedule/attendee/update/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res);
  },
  removeEventSchedule: (id: number) => {
    return adminApiRequest.delete(`/event-schedule/${id}`).then((res) => res);
  },
  removeEventAttendee: (id: number) => {
    return adminApiRequest
      .delete(`/event-schedule/attendee/${id}`)
      .then((res) => res);
  },
};
